export default [
    { //成果展示列表
        path: '/achievementsManagement',
        name:'achievementsManagement',
        meta: { title: '成果展示列表'},
        component: () => import('../../views/achievementsManagement/index.vue')
    },
    { //成果展示详情
        path: '/achievementsManagement/detail/:id',
        name:'achievementsManagementDetail',
        meta: { title: '成果展示详情'},
        component: () => import('../../views/achievementsManagement/detail.vue')
    },
    { //编辑成果展示
        path: '/achievementsManagement/edit/:tab/:id',
        name:'achievementsManagementEdit',
        meta: { title: '编辑成果展示'},
        component: () => import('../../views/achievementsManagement/edit.vue')
    },
    { //添加成果展示
      path: '/achievementsManagement/add/:tab',
      name:'achievementsManagementAdd',
      meta: { title: '添加成果展示'},
      component: () => import('../../views/achievementsManagement/add.vue')
  },
]